/**
 * Сравнивание цветов
 * @param {*} param0 Объект со значениями
 * @param {Array} param0.colors Массив цветов
 * @param {(brighter|darker)} param0.mode Опеределение наиболее светлого или темного цвета
 * @param {(color|array)} param0.returnable Возвращение string цвета или массива результатов сравнения
 * @returns {Array|String} Возвращает string цвета или массив с результатами сравнения
 */
function compare({ colors, mode = "brighter", returnable = "color" }) {
    let colours = [];
    for (let c of colors) colours.push({ sum: sumColor(c), color: c })

    // console.log(colours, mode)

    if (mode === "brighter") {
        colours = colours.sort((a, b) => b.sum - a.sum);
        return returnable == "color" ? colours[0].colour : colours;
    } else if (mode === "darker") {
        colours = colours.sort((a, b) => a.sum - b.sum);
        return returnable === "color" ? colours[0].colour : colours;
    }
}

/**
 * Определение наиболее контрастного цвета к цвету заднего фона
 * @param {*} param0 Объект со значениями
 * @param {Array} param0.colors Массив цветов
 * @param {String} param0.backgroundColor Цвет заднего фона
 * @param {(color|array)} param0.returnable Возвращение string цвета или массива результатов сравнения
 * @returns {Array|String} Возвращает string цвета или массив с результатами сравнения
 */
function bestForDisplay({ colors, backgroundColor, returnable = "color" }) {
    let bgc = sumColor(backgroundColor);
    let colours = compare({
        colors,
        returnable: "array"
    }).map(x => ({
        diff: Math.abs(bgc - x.sum),
        color: x.color,
        backgroundColor
    })).sort((a, b) => b.diff - a.diff)
    return returnable === "color" ? colours[0].color : colours;
}

function sumColor(c) {
    let _c;
    let _color_array = []
    if (c.includes('rgba')) {
        // rgba
        _color_array = c.replace('rgba(', '').replace(')', '').replace(/\s/g, '').split(',').map(x => Number(x));
    } else if (c.includes('rgb')) {
        // rgb
        _color_array = c.replace('rgb(', '').replace(')', '').replace(/\s/g, '').split(',').map(x => Number(x))
    } else {
        // hex
        let new_c = c.replace(/\s/g, '').replace('#', '');
        if (new_c.length == 3) {
            new_c = new_c[0].repeat(2) + new_c[1].repeat(2) + new_c[2].repeat(2)
        }
        if (new_c.length == 6) {
            // hex
            _color_array = "-".repeat(new_c.length / 2).split('').map((x, i) => (new_c.slice(i * 2, i * 2 + 2))).map(x => parseInt(x, 16));
        } else if (new_c.length == 8) {
            // hex + alpha
            _color_array = "-".repeat(new_c.length / 2).split('').map((x, i) => (new_c.slice(i * 2, i * 2 + 2))).map(x => parseInt(x, 16));
            _color_array[3] = Math.round(_color_array[3] * 0.392156) / 100;
        }
    }

    _c = (0.2126 * _color_array[0] + 0.7152 * _color_array[1] + 0.0722 * _color_array[2])

    if (_color_array.length == 4) {
        // count color with alpha
        _c = _c * _color_array[3];
    }

    return _c;
}



export default {
    compare,
    bestForDisplay,
    sumColor
};